import React, { Component } from 'react';
import AppSidebar from "../../components/AppSidebar";
import PageHeader from "../../components/PageHeader";
import ActionButton from "../../components/ActionButton";
import PanelGroupController from "../../components/PanelGroupController";
import FilterPanel from "../../components/panels/FilterPanel";
import {List, fromJS, Map} from "immutable";
import StockTransfersList from "./views/StockTransfersList";
import StockTransferDetails from "./views/StockTransferDetails";
import StockTransferStatusPanel from "./panels/StockTransferStatusPanel";
import StockTransferInfoPanel from "./panels/StockTransferInfoPanel";
import StockTransferActionsPanel from "./panels/StockTransferActionsPanel";
import {getAllWarehouses, addAllWarehousesOption} from "../../lib/Warehouses";

const statusFilterKey = "status";
const statusFilterOptions = fromJS([
  {id: "", label: "All Transfers"},
  {id: "draft", label: "Draft"},
  {id: "in_transit", label: "In Transit"},
  {id: "received", label: "Received"},
  {id: "cancelled", label: "Cancelled"},
])

const originFilterKey = "origin_warehouse_id";
const destinationFilterKey = "destination_warehouse_id";

class StockTransfersPage extends Component {

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Stock Transfers";
    if (page === "stock-transfer") {
      title = `${title} / ${this.props.params.id}`;
    }

    return (
      <div className="StockTransfersPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "stock-transfer"} onBack={this.handleBack.bind(this)} />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          {page === "stock-transfer"
            ? <StockTransferActionsPanel transferId={this.props.params.id} />
            : <PanelGroupController title="Actions">
                <ActionButton
                  label="Create Transfer"
                  onClick={this.handleCreateTransfer.bind(this)} />
                <ActionButton
                  label="Import Transfer"
                  onClick={this.handleImportTransfer.bind(this)} />
              </PanelGroupController>}
        </div>
      </div>
    );
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);
    switch(page) {
      case "stock-transfer":
        return (
          <StockTransferDetails
            transferId={this.props.params.id}
            />
        )
      case "stock-transfers":
      default:
        return (
          <StockTransfersList
            onSelectionChange={this.handleViewTransfer.bind(this)}
            statusFilter={searchQueries.get(statusFilterKey, "")}
            originFilter={searchQueries.get(originFilterKey, "")}
            destinationFilter={searchQueries.get(destinationFilterKey, "")}
            />
        )
    }
  }

  renderPanels(page) {
    if (page === "stock-transfer") {
      return List([
        <StockTransferStatusPanel key="StockTransferStatusPanel" transferId={this.props.params.id} />,
        <StockTransferInfoPanel key="StockTransferInfoPanel" transferId={this.props.params.id} />,
      ]);
    }
    return this.buildPanels(List(["statusFilter", "originFilter", "destinationFilter"]));
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    let searchQueries = Map(this.props.router.location.query);
    switch(component) {
      case "statusFilter":
        return <FilterPanel
          key="StatusFilterPanel"
          title="Status Filter"
          expanded={true}
          options={statusFilterOptions}
          onClick={(item) => this.setQueryKeyAndUpdate(statusFilterKey, item.get("id"))}
          filter={searchQueries.get(statusFilterKey, "")}
          />

      case "originFilter":
        return <FilterPanel
          key="OriginFilterPanel"
          title="Origin Warehouse"
          expanded={true}
          options={addAllWarehousesOption(getAllWarehouses())}
          onClick={(item) => this.setQueryKeyAndUpdate(originFilterKey, item.get("id"))}
          filter={searchQueries.get(originFilterKey, "")}
          />

      case "destinationFilter":
        return <FilterPanel
          key="DestinationFilterPanel"
          title="Destination Warehouse"
          expanded={true}
          options={addAllWarehousesOption(getAllWarehouses())}
          onClick={(item) => this.setQueryKeyAndUpdate(destinationFilterKey, item.get("id"))}
          filter={searchQueries.get(destinationFilterKey, "")}
          />

      default:
        return null;
    }
  }

  updateUrlQuery(query = Map()) {
    this.props.router.push({
      pathname: "/stock-transfers",
      query: query.toJS()
    });
  }

  setQueryKeyAndUpdate(key, val) {
    let queries = Map(this.props.router.location.query);
    if (val === "") {
      this.updateUrlQuery(queries.delete(key));
    } else {
      this.updateUrlQuery(queries.set(key, val));
    }
  }

  handleViewTransfer(id) {
    this.props.router.push(`/stock-transfers/${id}`);
  }

  handleBack() {
    this.props.router.push(`/stock-transfers`);
  }

  handleCreateTransfer() {
    this.props.requestCreateStockTransfer();
  }

  handleImportTransfer() {
    this.props.requestImportStockTransfer();
  }
}

export default StockTransfersPage;
